import { getAuth } from 'firebase/auth';

// Custom word sets, generated from any prompt (Matt, 2026-08-29: "you could
// just put in any prompt, and the game would generate a set of words").
//
// This goes through the codenames-ai Lambda so the API key never rides in
// the bundle; the endpoint verifies a Firebase ID token and refuses
// anonymous ones. NOTE the scope: the endpoint generates WORD SETS, and
// that is all. The no-robots decision stands - see CLAUDE.md.
//
// Unlike the sibling games' bot calls this THROWS on failure rather than
// falling back: the host is standing in the lobby waiting for their set,
// and a quiet fallback to Classic would look like the feature ignoring
// them. The store turns the error into a visible notice.

// Read at call time rather than module load: webpack inlines the env either
// way in a real build, and the tests set it after import.
const api = () => process.env.VUE_APP_AI_API_URL || '';

export const customSetsAvailable = () => Boolean(api());

export const generateWordSet = async (prompt) => {
  const API = api();
  if (!API) throw new Error('Custom sets need the words endpoint configured.');
  const user = getAuth().currentUser;
  if (!user) throw new Error('Sign in first.');
  const idToken = await user.getIdToken();
  const res = await fetch(`${API}/words`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${idToken}` },
    body: JSON.stringify({ prompt: String(prompt || '').slice(0, 200) }),
  });
  if (!res.ok) throw new Error(`The word smith is unavailable (HTTP ${res.status}).`);
  const { words } = await res.json();
  const cleaned = [...new Set((Array.isArray(words) ? words : [])
    .map((w) => String(w || '').trim().toUpperCase())
    .filter((w) => /^[A-Z]{2,16}$/.test(w)))];
  if (cleaned.length < 25) throw new Error('That prompt came back with too few usable words - try another.');
  return cleaned.slice(0, 120);
};
